export default __webpack_public_path__ + "static/brand-video@2x-81c7b6fd7662f9058b3d9fe055f645c2.png";